import React from 'react';
import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";

import css from "../PeriodsCreatePeriodModal/PeriodsCreatePeriodModal.module.css";
import {periodsActions} from "../../../../store/slices/settings-slices";
import {periodsService} from "../../../../services/settings-services";


const PeriodsUpdatePeriodModal = ({setIsOpenUpdate, period}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {id, daysCount, discount, isDefault} = period;

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues:{
            daysCount: daysCount,
            discount: discount,
            isDefault: isDefault,
        }
    });

    const submitHandler = async (data) => {
        try {
            await periodsService.updateById(id, {
                "daysCount": Number(data.daysCount),
                "discount": Number(data.discount),
                "isDefault": data.isDefault
            });
            dispatch(periodsActions.changeTrigger());
            toast.success('Period is updating!');
            setIsOpenUpdate(false);
        }catch (error) {
            console.error("Error updating period:", error);
            toast.error(t('modal-toast-creating-error'));
        }
    };

    const closeModal = () => {
        setIsOpenUpdate(false);
    }


    return (
        <section className={css.modalOverlay}>
            <div className={css.modal}>
                <button className={css.closeButton} onClick={closeModal}>
                    &times;
                </button>

                <h2 className={css.title}>{t('modal-periods-update-period')}</h2>
                <form onSubmit={handleSubmit(submitHandler)}>
                    <div className={css.inputGroup}>
                        <label htmlFor="daysCount">{t('Days-count')}</label>
                        <input
                            type="number"
                            id="daysCount"
                            {...register("daysCount", {required: "Days count is required"})}
                            className={errors.daysCount ? css.inputError : ""}
                        />
                        {errors.daysCount && (
                            <p className={css.error}>{errors.daysCount.message}</p>
                        )}
                    </div>

                    <div className={css.inputGroup}>
                        <label htmlFor="discount">{'Discount'}</label>
                        <input
                            type="number"
                            id="discount"
                            {...register("discount", {required: "Discount is required"})}
                            className={errors.discount ? css.inputError : ""}
                        />
                        {errors.discount && (
                            <p className={css.error}>{errors.discount.message}</p>
                        )}
                    </div>

                    <div className={css.checkboxGroup}>
                        <input
                            type="checkbox"
                            id="isDefault"
                            {...register("isDefault")}
                            className={css.checkbox}
                        />
                        <label htmlFor="isDefault">Default</label>
                    </div>

                    <article className={css.btnBlock}>
                        <button className={css.cancel} onClick={closeModal}>cancel</button>

                        <button className={css.save} type={'submit'}>save</button>
                    </article>
                </form>
            </div>
        </section>
    );
};

export {PeriodsUpdatePeriodModal};